import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';

import { SolutionDetails as SolutionDetailsView } from '../../../../Components/MockExam';
import { DialogContent } from './SolutionDetails';
import SolutionToolbar from './SolutionToolbar';

export default class SolutionLoadingView extends Component {
  static propTypes = {
    title: PropTypes.string,
  };

  render() {
    const { title } = this.props;
    return (
      <Fragment>
        <SolutionToolbar />
        <Paper elevation={24}>
          <DialogContent borderless>
            <SolutionDetailsView title={title} loading />
          </DialogContent>
        </Paper>
      </Fragment>
    );
  }
}
